<ion-header>
	<form [formGroup]="form" *ngIf="form">
		<ion-item lines="full" *ngIf="appointment">
			<ion-label position="stacked">Linecard</ion-label>
			<ion-select
				[formControl]="form.controls.linecard"
				[compareWith]="compareWith"
				[value]="form.controls.linecard.value"
				(ionChange)="onChangeLinecard()"
			>
				<ion-select-option
					*ngFor="let linecard of appointment.linecards"
					[value]="linecard"
				>
					{{ linecard.description || linecard.linecardId }}
				</ion-select-option>
			</ion-select>
		</ion-item>
	</form>
</ion-header>

<ion-content>
	<ng-container *ngIf="appointment; else loading">
		<ng-container *ngIf="appointment.linecards?.length > 0; else empty">
			<ion-grid class="linecard-details">
				<ion-row *ngFor="let detail of details">
					<ion-col size="4">
						{{ detail.label }}
					</ion-col>
					<ion-col size="8">
						<ng-container *ngIf="detail.format; else print">
							<app-scrollable-text>
								<div
									class="customer-service"
									[innerHTML]="
										detail.format(
											selectedLinecard[detail.field]
										)
									"
								></div>
							</app-scrollable-text>
						</ng-container>
						<ng-template #print>
							{{ selectedLinecard[detail.field] || "N/A" }}
						</ng-template>
					</ion-col>
				</ion-row>
			</ion-grid>
			<ion-item-group
				*ngFor="let el of selectedLinecard?.elements; index as index"
			>
				<ion-item
					lines="full"
					button
					mode="md"
					(click)="onClickToggleSection(index)"
				>
					<ion-icon
						slot="end"
						[name]="
							isVisible(index)
								? 'chevron-up-outline'
								: 'chevron-down-outline'
						"
					></ion-icon>
					<ion-text>{{ el.type }}: {{ el.desc }}</ion-text>
				</ion-item>
				<ion-item
					*ngIf="isVisible(index)"
					lines="full"
					color="light"
					mode="md"
				>
					<ion-grid>
						<ion-row>
							<ion-col size="4">
								<strong>Status:</strong>
							</ion-col>
							<ion-col size="8">
								{{ el.status }}
							</ion-col>
						</ion-row>
						<ion-row>
							<ion-col size="4">
								<strong>Location:</strong>
							</ion-col>
							<ion-col size="8">
								{{ el.location }}
							</ion-col>
						</ion-row>
						<ion-row>
							<ion-col size="4">
								<strong>Shared:</strong>
							</ion-col>
							<ion-col size="8">
								{{ el.shared ? "Yes" : "No" }}
							</ion-col>
						</ion-row>
						<ion-row>
							<ion-col size="12">
								<ion-button
									(click)="onClickAddChangeComment(el)"
									expand="block"
								>
									Add Change Comment
								</ion-button>
							</ion-col>
						</ion-row>
					</ion-grid>
				</ion-item>
			</ion-item-group>
		</ng-container>

		<ng-template #empty>
			<app-empty-list-item
				message="No Linecards on Structure"
			></app-empty-list-item>
		</ng-template>
	</ng-container>

	<ng-template #loading>
		<app-loader message="Fetching Linecards"></app-loader>
	</ng-template>
</ion-content>
